export default __webpack_public_path__ + "e8aac91ee9bf7e8600ffb5173ac2e4aa.svg";